export * from './no-content.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/no-content/index.ts